import sortBy from 'lodash/sortBy'

export default {
  data() {
    return {
      lastSortedFiles: null
    }
  },
  computed: {
    computedSortIcon() {
      return this.selectedSortDir === 'asc' ? 'sort-up' : 'sort-down'
    },
    selectedSort() {
      return this.element.data.sort || 'rank'
    },
    selectedSortDir() {
      return this.element.data.sort_dir || 'asc'
    },
    childrenSorted() {
      if (this.selectedSort === 'rank') {
        return this.children
      }

      if (this.focused === 'sort') {
        return this.lastSortedFiles
      }

      let children = [...this.children]

      children = sortBy(children, [
        (o) => {
          switch (this.selectedSort) {
            case 'rank':
            default:
              return o.rank
            case 'name':
              return o.data.name ? o.data.name : o.file.name
            case 'ext':
              return o.file.ext
            case 'added':
              return o.file.uploaded
            case 'size':
              return o.file.size
          }
        }
      ])

      if (this.selectedSortDir === 'desc')
        return (this.lastSortedFiles = children.reverse())
      return (this.lastSortedFiles = children)
    }
  },
  methods: {
    changeSort(sort) {
      if (sort === this.element.data.sort && sort !== 'rank') {
        if (this.selectedSortDir === 'desc' || !this.element.data.sort_dir) {
          this.element.data.sort_dir = 'asc'
        } else {
          this.element.data.sort_dir = 'desc'
        }
      } else {
        this.element.data.sort_dir = 'asc'
      }

      this.element.data.sort = sort

      if (this.bcDocumentStore.edit) {
        this.element.updated = true
      }
    }
  }
}
